import TcForm from 'components/UI/form/TcForm';
import TcFormItem from 'components/UI/form/TcFormItem';
import TcInput from 'components/UI/form/input/TcInput';
import { FC } from 'react';

interface IOrderSummeryTraceCode {
  setTraceCode: (_traceCode: string) => void;
  traceCode?: string;
}

const OrderSummeryTraceCode: FC<IOrderSummeryTraceCode> = ({ setTraceCode, traceCode }) => {
  return (
    <div className='w-full pt-6'>
      <TcForm>
        <TcFormItem
          label='کد رهگیری شخصی (اختیاری)'
          className='md:max-w-lg'
          tooltip='با پرکردن کد رهگیری شخصی شما میتوانید لیست سفارش ها را با استفاده از کد های وارد شده خود فیلتر کنید. توجه داشته باشید، کد رهگیری نمیتواند تکراری باشد.'>
          <TcInput placeholder='کد رهگیری شخصی (اختیاری)' value={traceCode || ''} onChange={(e) => setTraceCode(e.target.value)} />
        </TcFormItem>
      </TcForm>
    </div>
  );
};

export default OrderSummeryTraceCode;
